import './config/sentry';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { CircularProgress, Box } from '@mui/material';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { Loading } from './components/ui/Loading';

// Loading component while translations are being loaded
const LoadingComponent = () => (
  <Loading message="Carregando..." />
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Suspense fallback={<LoadingComponent />}>
      <App />
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
